import React, { PropTypes } from 'react';
import Form, { FormActions, FormBody, TextInput } from "../../Form";
import { inject, observer } from 'mobx-react';
import { observable, action } from 'mobx';

@inject('systemStore', 'rolePermissionStore')
@observer
class System extends React.Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
  };

  @observable config = {
    app_title: '',
    organization_name: '',
    app_version: '',
    // db_host: '',
    // db_port: '',
    // db_user: '',
    // db_password: '',
    // db_name: '',
  }

  @action onChangeConfig = (key, value) => this.config[key] = value;

  componentWillMount() {
    const { systemStore } = this.props;
    systemStore.fetchConfig().then(config => {
      Object.keys(this.config).forEach(key => {
        if (!!config[key]) this.config[key] = config[key];
      })
    });
  }

  handleSave = e => {
    e.preventDefault();
    const { notify } = this.context;
    this.props.systemStore.updateConfig(this.config).then(notify.success).catch(notify.error)
  };

  render() {
    const canModify = this.props.rolePermissionStore.validateRole('modify configurations');
    return (
      <div>
        <Form>
          <FormBody>
            {Object.keys(this.config)
              .map((key, index) =>
                <TextInput
                  key={`config-${key}`} label={key}
                  value={this.config[key]}
                  onChange={e => this.onChangeConfig(key, e.target.value)}
                  readOnly={!canModify}
                />
              )}
          </FormBody>
          {canModify && <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>}
        </Form>
      </div>
    );
  }
}

export default System;


// WEBPACK FOOTER //
// ./src/components/SystemConfiguration/System/System.js